import ResumeItem from '@/common/components/ResumeItem'
import { formatPercentage } from '@/common/utils/formatters'
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'

interface ProposalAwareResumeItemProps {
  label: string
  originalValue: number
  newValue: number | null | undefined
  differencePercentage?: string | null
  format: (value: number) => string
  higherIsBetter?: boolean
}

const ProposalAwareResumeItem = ({
  label,
  originalValue,
  newValue,
  differencePercentage,
  format,
  higherIsBetter = false,
}: ProposalAwareResumeItemProps) => {
  const hasModification = newValue !== null && newValue !== undefined

  if (!hasModification) {
    return <ResumeItem className="text-sm" label={label} value={format(originalValue)} />
  }

  const increasedClass = higherIsBetter ? 'text-valid' : 'text-danger-soft'
  const decreasedClass = higherIsBetter ? 'text-danger-soft' : 'text-valid'

  const newValueClassName = newValue > originalValue ? increasedClass : newValue < originalValue ? decreasedClass : ''

  const differencePercentageNumber = differencePercentage != null ? Number(differencePercentage) : null

  const showDifferencePercentage = differencePercentageNumber != null && differencePercentageNumber !== 0

  return (
    <ResumeItem
      className="text-sm"
      label={label}
      value={
        <span className="flex items-center gap-1">
          <span className={newValueClassName}>{format(newValue)}</span>

          <span className="text-xs text-white-400 line-through">{format(originalValue)}</span>

          {showDifferencePercentage && (
            <span className="text-[9px] text-white-800 rounded-full px-1 bg-yellow-op-2 inline-flex items-center">
              {differencePercentageNumber > 0 ? (
                <ArrowUpIcon className={`size-3 ${increasedClass}`} />
              ) : (
                <ArrowDownIcon className={`size-3 ${decreasedClass}`} />
              )}
              {formatPercentage(Math.abs(differencePercentageNumber))}
            </span>
          )}
        </span>
      }
    />
  )
}

export default ProposalAwareResumeItem
